import { render, staticRenderFns } from "./StockItem.vue?vue&type=template&id=fca6c886&scoped=true&"
import script from "./StockItem.vue?vue&type=script&lang=js&"
export * from "./StockItem.vue?vue&type=script&lang=js&"
import style0 from "./StockItem.vue?vue&type=style&index=0&id=fca6c886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca6c886",
  null
  
)

export default component.exports